export default __webpack_public_path__ + "static/media/Mobile-04.a7f89f97.jpg";